/**
 * RESPONSIBILITY: the Children's Ministry page's closing invitation.
 *
 * No @EditableBy, so WRITE defaults to NONE — admin only.
 */
import { Section, Text, Paragraph, Link } from '@framework/core/decorators';
import { SectionName } from '../section-names';
import { LINK_HINT } from '../hints';

@Section({ name: SectionName.ChildrenCta, label: 'Children — closing' })
export class ChildrenCtaSection {
  @Text({ label: 'Title', maxLength: 600 })
  ctaHeading!: string;

  @Paragraph({ label: 'Description', maxLength: 4000, rows: 3 })
  ctaBody!: string;

  @Text({ label: 'Button text', maxLength: 120, default: 'Plan a visit' })
  ctaLabel!: string;

  @Link({ label: 'Button link', description: LINK_HINT })
  ctaHref!: string;
}
